module.exports = __webpack_public_path__ + "static/media/iconfinder_website_-_calendar_schedule_3440831.99d31c2c.png";